var render = function render(_c,_vm){return _c('span',{staticClass:"vrm-modal__close-handle sg-vrm-icon_060_cross-round-24px mfp-close"})
}
var staticRenderFns = []

export { render, staticRenderFns }